export default function getAccess(module){
    var modulAcl = this.userPreferences.acl[module];
    if(modulAcl != undefined){
        return Object.assign({}, modulAcl)
    }
    return modulAcl;
}